import script from "./goRinSyo0025.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0025.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0025.vue?vue&type=style&index=0&id=9d8a054e&lang=scss"

const __exports__ = script;

export default __exports__